/*******
** Animations
** ------------
** Managing all primary page-level Animations within the application
*******/
App.Animations = (function() {

	// Constants
	var selectors = {
		blocks: ".block"
	};
  var flags = {
    ENTER: "block-enter",
    SEEN: "block-seen",
  };

  function blockAnimationEnter(el) {
    $(el).addClass(flags.ENTER);
  }
  function blockAnimationExit(el) {
    $(el).addClass(flags.SEEN);
  }

	function animateBlocks() {
    if(inView) {
  		// Set threshold for inView
  		inView.offset(200);

  		// Attach globally to blocks
  		inView(selectors.blocks).on("enter", blockAnimationEnter);

  		// Force a check
  		inView(selectors.blocks).check();
    }
	}

	App.register(function() {
		App.log("Registered: App.Animations");
    animateBlocks();
	});

	return {
		// Public varants
		GSAP: {
			EASE: "power1.inOut"
		}
	}

})();
